import ViewLocation from "./ViewLocation";

export default ViewLocation;